import { FormattedMessage } from 'react-intl';
import { PaloNextThemeProvider } from '@synergy/theme-palo';
import { PoolButton, PoolModal, PoolModalActions, PoolModalContent, PoolModalTitle } from '@synergy/components-next';
import { ReactElement, useState } from 'react';
import { Stack } from '@mui/material';

import {
    BonusSettlementSearchSupplier,
    BonusSettlementSupplier,
} from '../../models/bonus-settlement-supplier-overview';
import { PoolBonusSettlementSupplierAutocompleteList } from './bonus-settlement-supplier-overview-autocomplete-list';
import { addSupplier } from '../store/bonus-settlements-supplier-overview-actions';
import { useThunkDispatch } from '../../../../../store/use-thunk-dispatch';

export interface AddSupplierFormValues {
    supplier: BonusSettlementSupplier | null;
}

export interface AddSupplierModalProps {
    open: boolean;
    bonusSettlementId: number;
    onClose: () => void;
}

export const AddSupplierModal = (props: AddSupplierModalProps): ReactElement => {
    const { open, onClose, bonusSettlementId } = props;
    const dispatch = useThunkDispatch();

    const [searchSupplier, setSearchSupplier] = useState<BonusSettlementSearchSupplier | null>(null);

    const handleSubmit = async () => {
        if (searchSupplier) {
            dispatch(addSupplier({ bonusSettlementId: bonusSettlementId, supplierId: searchSupplier.id }));
        }

        onClose();
    };

    const handleSupplierSelected = async (supplier: BonusSettlementSearchSupplier | null) => {
        setSearchSupplier(supplier);
    };

    return (
        <PaloNextThemeProvider>
            <PoolModal open={open} onClose={onClose}>
                <PoolModalTitle>
                    <FormattedMessage id="app.bonusSettlementsSupplierOverview.action.addSupplier" />
                </PoolModalTitle>
                <PoolModalContent>
                    <Stack gap={4}>
                        <Stack gap={2}>
                            <PoolBonusSettlementSupplierAutocompleteList
                                label={<FormattedMessage id="app.label.supplierAccount" />}
                                onSelected={handleSupplierSelected}
                                bonusSettlementId={bonusSettlementId}
                                readOnly={false}
                            />
                        </Stack>
                    </Stack>
                </PoolModalContent>
                <PoolModalActions>
                    <PoolButton variant="outlined" onClick={onClose}>
                        <FormattedMessage id="app.common.cancel" />
                    </PoolButton>
                    <PoolButton onClick={handleSubmit}>
                        <FormattedMessage id="app.common.add" />
                    </PoolButton>
                </PoolModalActions>
            </PoolModal>
        </PaloNextThemeProvider>
    );
};
